// extracted by mini-css-extract-plugin
export default {"ExpenseAccountImportError":"gcgmw_I8oZ80Kjhnzw7R"};